//请自行添加语言资源
const logDashboardDetail = {
  oneMenu:'一级菜单',
  twoMenu:'二级菜单',
  createTime:"操作时间",
  creator:"操作人工号",
  createName:"操作人",
  msg:{

  }
};
export default logDashboardDetail



// WEBPACK FOOTER //
// ./src/page/int/logDashboardDetail/lang/logDashboardDetail.zh.js